import styled from 'styled-components';

export const getTileGradient = (color) => {

    let newColor = color + "00"

    return (
        `linear-gradient(180deg, ${newColor} 0%, ${color} 100%)`
    )
}

export const StyledTilesPageContainer = styled.div`
    overflow: hidden;
`;

export const TilesPageBackground = styled.div`
    width: 100vw;
    height: 100vh;
    position: relative;
    background: ${({ $backgroundColor, theme }) => $backgroundColor || theme?.themeC4 || '#1e1f23'};
    video {
        object-fit: cover;
    }
`
export const BackgroundTransition = styled.div`
    position: relative;
    margin-top: -20vh;
    height: 20vh;
    width: 100%;
    background: linear-gradient(to bottom, rgba(30,31,35,0), rgba(30,31,35,1));
    // background: ${({ theme }) => getTileGradient(theme?.themeC4)};
    background-size: 100%;
    background-repeat: no-repeat;
`;

export const TileContainer = styled.div`
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
`


export const TilesPageImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
`

export const MuteUnmuteIcon = styled.img`
    width: 25px;
    height: 25px;
    position: absolute;
    top: 100px;
    right: 1.5vw;
    z-index: 99;
    &:hover {
        cursor: pointer;
    }
`

export const StyledTilesList = styled.div`
    // background: linear-gradient(to bottom, #1e1f2300, #1e1f23ff);
    background: ${({ theme }) => theme?.themeC4};
    background-size: 100% auto;
    background-repeat: no-repeat;
    position: relative;
`;

export const TilesPageEmptyState = styled.div`
    position: absolute;
    inset: 0;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
    padding: 120px 24px 48px;
    text-align: center;
    color: #ffffff;
    background: linear-gradient(180deg, rgba(18, 19, 23, 0.22), rgba(18, 19, 23, 0.58));

    h1 {
        max-width: 720px;
        margin: 0;
        font-family: Outfit, sans-serif;
        font-size: 32px;
        font-weight: 700;
        line-height: 1.15;
    }

    p {
        max-width: 640px;
        margin: 0;
        font-family: Outfit, sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 1.5;
        color: rgba(255, 255, 255, 0.86);
    }

    @media (max-width: 520px) {
        padding: 96px 20px 40px;

        h1 {
            font-size: 26px;
        }

        p {
            font-size: 15px;
        }
    }
`;

